import axios from '@/store/interceptor';
import apiUrl from '@/config/api.config';

// Fresh profile (role, departments) for the stored session; 401 = account blocked -> the interceptor logs out
export async function fetchMe() {
    const response = await axios.get(`${apiUrl}/auth/me`);
    return response.data;
}
